import { IconButton, IconButtonCategory, IconButtonSize, IconVariant } from "@/DesignSystem";

import DownloadSimple from "@/DesignSystem/Atoms/Icons/Types/DownloadSimple/download-simple-regular.svg";

function DownloadIconButton(
    props: Readonly<{
        id?: string,
        dataCy?: string,
        disabled?: boolean,
        variant?: IconVariant;
        size?: IconButtonSize,
        category?: IconButtonCategory;
        onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    }>
): JSX.Element {
    return (
        <IconButton
            id={props.id}
            dataCy={props.dataCy}
            disabled={props.disabled}
            variant={props.variant ?? "brand"}
            category={props.category ?? "secondary"}
            size={props.size ?? "sm"}
            onClick={props.onClick}
        >
            <DownloadSimple />
        </IconButton>

    );
}

export { DownloadIconButton };
